var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('div',{staticClass:"world-map-section"}),_vm._v(" "),_c('sdr-keydestinations',{attrs:{"modulo":"flightplan"}}),_vm._v(" "),_c('sdr-flightplantable',{on:{"clickdepartureairport":_vm.onClick_DepartureAirportInFlightplanTable,"clickresetmap":_vm.onClick_ResetMap}}),_vm._v(" "),_c('sdr-promobox-sundair-app')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-508322ba","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/flightplan/Home.vue
// module id = 566
// module chunks = 0